/* tslint:disable:max-line-length */
/**
 * 1
 * Alza API 1
 * Alza Rest Api Swagger Documentation
 *   "path": null
 */

import * as model from '../model'

/** Teammember Role Resource */
export interface TeamMemberRoleV1 {
  /**
   * Id Of Vendor Team
   * format: int32
   */
  vendorTeamId: number
  /**
   * Role Name Options: [1 = TeamAdmin, 10 = TeamManager, 20 = TeamMember]
   * format: int32
   */
  role: RoleTeamMemberRoleV1Enum
  meta?: model.MetaInfo
}

export enum RoleTeamMemberRoleV1Enum {
  TeamAdmin = 1,
  TeamManager = 10,
  TeamMember = 20,
}



// WEBPACK FOOTER //
// ./src/app/api/api/models/team-member-role-v1.ts